module.exports = __webpack_public_path__ + "static/neighborhoods-mobile.d8120590.webp";